import { useEffect, useState } from 'react';
import { serverNow } from '../state/roomStore';

/**
 * Server-clock "now" (local clock + offset from the latest `serverNow`),
 * re-rendering every `intervalMs` while `active`. Ticks are aligned to whole
 * seconds so countdowns change digits in step with the real clock.
 */
export function useServerNow(active = true, intervalMs = 1000): number {
  const [now, setNow] = useState(() => serverNow());
  useEffect(() => {
    if (!active) return;
    let timer: ReturnType<typeof setTimeout>;
    const tick = () => {
      const t = serverNow();
      setNow(t);
      timer = setTimeout(tick, intervalMs - (t % intervalMs) + 5);
    };
    tick();
    return () => clearTimeout(timer);
  }, [active, intervalMs]);
  return now;
}
